import React, { useEffect, useMemo, useState} from 'react';
import {StyledDiv, StyledIndexContainerDiv, StyledLeadContainer} from '../../Components/Styled/index';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import SearchLeadComponenet from './SearchLead';
import { privateRoutesPath } from '../../Routes';
import DataGridTable from './LeadTable';
import {useSnackbar} from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { getEntityColumns, isValidEmail, updateRequestData } from '../../Utility/apiHelper';
import { ACTIVE_STATUS, CUSTOMIZABLE_FIELDS_LEAD, handleValidateCodevalue, LEAD_STATUS, LEAD_STATUS_PROSPECT, phoneCountryCodes, searchEntity,STATIC_ENTITY_CONFIG } from '../../Utility/constant';
import { Tooltip, Typography } from '@mui/material';
import BiztantuSearch from '../../Components/BiztantuSearch';
import { requestGetLeadsPaged } from '../../Store/Lead/action';
import { requestHideLoader, requestShowLoader } from '../../Store/Global/action';
import SendNotification from '../../Components/SendNotification';
import { useSearchExecutor } from '../../Components/CustomHooks/useSearchExecutor';
import { useLeadStatusSearch } from '../../Components/CustomHooks/useStatusSearch';
import RefreshIcon from '@mui/icons-material/Refresh';
import BiztantuLoader from '../../Components/Loader';
import { useIsMobile } from '../../Utility/hooks/useIsMobile';
import AddIcon from '@mui/icons-material/Add';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { setSearch } from '../../Store/SearchReducer/action';
import { resetState } from '../../Utility/resetSearchFunction';
import { buildEntitySearchValues } from '../../Utility/buildEntitySearchValues ';
import { usePaginatedSearch } from '../../Utility/hooks/usePaginatedSearch';
import useNavigation from '../../Utility/hooks/useNavigation';
import './Lead.css';

const Leads = ({isLeadScreen = true ,handleOpenCsvpop}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [LeadTableData, setLeadTableData] = useState([]);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const isMobile = useIsMobile();
    const pagedLeadData = useSelector(state => state?.lead?.pagedLead)
    const dispatch = useDispatch();
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const today = new Date();
    const daysAgo = new Date();
    daysAgo.setDate(today.getDate() - 90);
    const leadSearch = useSelector((state) => state?.search?.lead) || {};

  const location = useLocation();
    const ownerlist = useSelector(state => state?.owner?.ownerlist);  
    const myTeam = useSelector(state => state?.owner?.Team);  
    const [ownerlistdropdown, setownerlistdropdown] = useState([]);
    const lookupData = useSelector(state => state?.lookup?.lookupData);
    const leadStatusData = useMemo(() => {
        return lookupData?.find((item) => item?.name == LEAD_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    }, [lookupData]);
    const allEntityData = useSelector((state) => state?.customization?.allEntityData || []);
    const leadTextfieldsData = useMemo(() => {
        const data = getEntityColumns(allEntityData, "LEAD");
        const {id,customerId,status ,...rest} = Object.keys(data).length > 0 ?  data : STATIC_ENTITY_CONFIG?.LEAD;
            return rest
    }, [allEntityData]);
    
    const { navigateTo } = useNavigation();
    const preserveSearch = useSelector(
      state => state?.search?.preserveSearch?.[searchEntity?.lead]
    );
    const { updatedSearch, newList } = useMemo(() => 
            buildEntitySearchValues({
                entity: searchEntity?.lead,
                currentUser,
                specificRolePermission,
                ownerlist,
                myTeam,
                statusData: leadStatusData,
                daysAgo,
                today,
                isAllManage: specificRolePermission?.isAllLeadManage,
                isTeamManage: specificRolePermission?.isLeadTeamManage,
                internationalise,
                handleValidateCodevalue,
                phoneCountryCodes,
            }), [currentUser, specificRolePermission, ownerlist, myTeam, leadStatusData, internationalise]);
    


        useEffect(() => {
    setownerlistdropdown(newList);
    }, [newList]);

const isReady =
    (myTeam?.length > 0  ||
    ownerlist?.length > 0) &&
    currentUser?.userId &&
    internationalise &&
    Object.keys(internationalise).length > 0



    // useEffect(() => {
    // const updatedLeadTable = (leadData|| []).map((item,index)=>{
    //             const countryCode = item?.phoneCountryCode || "";
    //             const phone = item?.phone || "";
    //                     return {
    //                         ...item,
    //                         phone: countryCode && phone ? `${countryCode}${phone}` : "",
    //                         createdat: moment(item.createdAt).format('MM/DD/YYYY'),
    //                         updatedat: moment(item.updatedAt).format('MM/DD/YYYY'),
    //                     }
    //                 })
    //                 setLeadTableData(updatedLeadTable);
    //      }, [leadData]);
    
        const handleChangeSearchField = (event) => {
            dispatch(setSearch(searchEntity?.lead, {
                ...leadSearch,
                [event.target.name]: event.target.value,
            }));
        };
    
    const handleSelectOwner = (event, owners) => {
        if ((!owners || owners.length === 0) && !specificRolePermission?.isAllLeadManage) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_SELECT_OWNER_WARNING"), { variant: "warning" });
            return;
        }
        dispatch(
            setSearch(searchEntity?.lead, {
                selectedOwner: owners,
                ownerName: owners?.map(o => o.name).join(", "),
            })
        );
    };
    const handleResetSearch = () => {
      dispatch(
          setSearch(searchEntity?.lead,resetState(leadSearch, {
            selectedOwner : leadSearch?.selectedOwner,
            ownerName :  leadSearch?.ownerName,
          })
        )
      );
    };
 const {buildSearchParams,executeSearch} = useSearchExecutor({
    ownerlist,
    myTeam,
    setIsLoading,
    enqueueSnackbar,
    internationalise,
    handleValidateCodevalue,
  });

const {
  paginationState,
  search: handleSearchLeadPaged,
  changePage: handlePageChange,
  changePageSize: handlePageSizeChange,
} = usePaginatedSearch({
  entity: searchEntity?.lead,
  searchState: leadSearch,
  getInitialState: () => updatedSearch,
  preserveSearch,
  isReady,
  buildParams: (overrideSearch) => buildSearchParams(overrideSearch ?? leadSearch),
  executeSearch,
  searchAction: requestGetLeadsPaged,
});

const { handleStatusSearch } = useLeadStatusSearch({
  leadStatusData,
  leadsearch: leadSearch,
  enqueueSnackbar,
  internationalise,
  handleValidateCodevalue,
  statusCode: LEAD_STATUS_PROSPECT,
  searchEntity: searchEntity?.lead,
  handleSearchLeadPaged,
});


    const handleUpdateLead = async(newRow) => {
        if(!isValidEmail(newRow?.email)){
        enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_VALID_EMAIL"),{variant:'error'});
        return;
        }
        setIsLoading(true);
        const leadId = newRow?.id;
        const { createdat, updatedat, id, ...payload } = newRow;
        const url = `${process.env.REACT_APP_BASE_URL}leads/${leadId}`
        dispatch(requestShowLoader())
        const responseData = await updateRequestData(payload, url);
        if(responseData?.status == 200) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_UPDATED_SUCCESSFULLY'), {variant: 'success'});
            handleSearchLeadPaged(paginationState.page);
            dispatch(requestHideLoader());
        }
        else {
            enqueueSnackbar(handleValidateCodevalue(internationalise,responseData?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN") , {variant : 'error'});
            dispatch(requestHideLoader());
        }
    setIsLoading(false);
    }

    const leadSearchBox = {
        ...leadSearch,
    }

 const handleNotifyLeadFromLeadPage = async(selectedLead) => {
          setIsOpenNotificationDialog({
            ...isOpenNotificationDialog,
            selectedDetails : selectedLead,
            isOpen : true,
        });
    }

    
    const [isOpenNotificationDialog,setIsOpenNotificationDialog] = useState({
        isOpen : false,
        selectedDetails : []
    })
    
    const isLoadingProgress = useSelector(state => state?.global?.isLoading);

    const handleSelectAutocomplete = (e,value,name)=>{
        dispatch(setSearch(searchEntity?.lead, {
            ...leadSearch,
            [name] : value
        }));
    }
    const handleCreatePage = () => {
       navigateTo(privateRoutesPath.CREATE_LEAD,{},searchEntity?.lead);
    }
    return(
        <BiztantuLoader isChildren={true} open={isLoadingProgress}>
        <StyledDiv>
            {isLeadScreen && <StyledLeadContainer>
            <Typography variant='h6' className='mb-20'>
                {handleValidateCodevalue(internationalise,'LEAD_SEARCH_TITLE')}
            </Typography>
            </StyledLeadContainer>}
            {/* <SearchLeadComponenet 
                handleSearchLead={handleSearchLead}
            /> */}
            <StyledIndexContainerDiv>
                 {isLeadScreen &&
                 <StyledLeadContainer className="lead-filter-container">
                    <Stack className='table-header-search table-header-search-common' 
                        flexWrap={isMobile ? "nowrap" : ""} 
                        width={isMobile ? "100%" : "30%"}
                        alignItems = "center"
                        flexDirection = {isMobile ? "row" : ""}
                        justifyContent={isMobile ? "space-between" : ""}
                        mb = {isMobile ? 2 : 0}
                        bgcolor = {isMobile ? "#F4F9FE !important" : "#FFFFFF" }
                    >
                            <BiztantuSearch
                            showStatus = {false}
                            showOwner = {true}
                            entityDetails = {leadSearchBox}
                            ownerlistdropdown = {ownerlistdropdown}
                            handleReset = {handleResetSearch}
                            handleSearch = {() => handleSearchLeadPaged(0)}
                        >
                            <SearchLeadComponenet
                                handleSelectStatus = {handleSelectAutocomplete}
                                handleSelectOwner = {handleSelectOwner}
                                ownerlistdropdown = {ownerlistdropdown}
                                entityDetails = {leadSearch}
                                handleOnChange = {handleChangeSearchField}
                                handleResetSearch={handleResetSearch}
                            />
                        </BiztantuSearch>
                    
                        {isMobile &&
                            <Stack className='mb-10' flexDirection={"row"} display={"flex"} justifyContent={"space-between"} gap = {2}>
                            <Tooltip
                                title={handleValidateCodevalue(internationalise, "COMMON_REFRESH")}
                                onClick={() => handleSearchLeadPaged(paginationState.page)}
                                >
                                <Button
                                    className='biztantu-sec-btn-mobile'
                                    variant="outlined"
                                >
                                <RefreshIcon />
                                </Button>
                            </Tooltip>
                            <Tooltip
                                title={handleValidateCodevalue(internationalise, 'LEAD_CREATE')}
                                onClick={handleCreatePage}
                                >
                                <Button
                                    className='biztantu-sec-btn-mobile'
                                    variant="outlined"
                                >
                                <AddIcon />
                                </Button>
                            </Tooltip>
                            </Stack>
                        }
                    </Stack>
                    {!isMobile &&
                    <Stack className='secondry-btn-container' flex={1} padding="10px" justifyContent="space-between" flexWrap={'wrap'} spacing={2} direction="row">
                      <Stack>
                        <Button 
                        // startIcon={<img  style={{height: "15px"}} />} 
                            className='biztantu-sec-btn' 
                            disabled={!specificRolePermission?.isLeadManage && !specificRolePermission?.isAllLeadManage}
                            onClick={handleStatusSearch}>
                                {handleValidateCodevalue(internationalise,"COMMON_SHOW_PROSPECTS")}
                            </Button>
                    </Stack>
                    {(specificRolePermission?.isLeadManage || specificRolePermission?.isAllLeadManage) &&
                    <Stack display="flex" 
                    marginLeft={"0px !important"} 
                    flexWrap={'wrap'} justifyContent="flex-end" spacing={2} direction="row">
                        <Tooltip
                            title={handleValidateCodevalue(internationalise, "COMMON_REFRESH")}
                            onClick={() => handleSearchLeadPaged(paginationState.page)}
                        >
                        <Button
                            className="biztantu-sec-btn"
                            variant="outlined"
                        >
                            <RefreshIcon />
                        </Button>
                        </Tooltip>
                        <Button
                        className="biztantu-sec-btn"
                        onClick={() =>
                           navigateTo(privateRoutesPath.COMMON_BULK_UPLOAD,
                            {
                                preserveSearch : preserveSearch,
                                selectedEntity : "LEAD",
                                removeFields : [
                                    "selectedOwner",
                                    "selectedSource",
                                    "desirability",
                                    "totalValue", 
                                ],
                                CUSTOMIZABLE_FIELDS : CUSTOMIZABLE_FIELDS_LEAD,
                                title: "LEAD_BULK_UPLOAD_TITLE",
                                customizationData : leadTextfieldsData,
                                from: location.pathname,
                                searchEntity : searchEntity?.lead
                            },
                            searchEntity?.lead
                        )
                        }
                        >
                        {handleValidateCodevalue(
                            internationalise,
                            "LEAD_BULK_UPLOAD"
                        )}
                        </Button>
                        <Button className='biztantu-sec-btn'  variant="outlined" onClick={handleCreatePage}>{handleValidateCodevalue(internationalise,"LEAD_CREATE")}</Button>
                    </Stack>
                    }
                    </Stack>
                    }
                </StyledLeadContainer>
                }
                <DataGridTable
                leadTextfieldData = {leadTextfieldsData}
                    handleSearch = {handleSearchLeadPaged}
                    height="calc(100vh - 218px)"
                    isLoading = {isLoading}
                    // LeadTableData={LeadTableData}
                    handleUpdateLead={handleUpdateLead}
                    isRequiredToolBar = {true}
                    isLeadScreen = {isLeadScreen}
                    specificRolePermission = {specificRolePermission}
                    handleNotifyLead = {(selectionmodal) => isLeadScreen ? handleNotifyLeadFromLeadPage(selectionmodal) : handleNotifyLeadFromLeadPage(selectionmodal)}
                    pagedLeadData={pagedLeadData}
                    paginationState={paginationState}
                    onPageChange={handlePageChange}
                    onPageSizeChange={handlePageSizeChange}
                />
            </StyledIndexContainerDiv>
                {
                    (isOpenNotificationDialog?.isOpen) && (
                        <SendNotification
                            open={isOpenNotificationDialog?.isOpen}
                            title= {handleValidateCodevalue(internationalise,"COMMON_NOTIFY_LEAD")}
                            selectedDetails={isOpenNotificationDialog?.selectedDetails}
                            setIsOpenNotificationDialog = {setIsOpenNotificationDialog}
                            type = {"Lead"}
                            entityType = {"Lead"}
                            />
                    )
                }
        </StyledDiv>
        </BiztantuLoader>
    )
}

export default Leads;